// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"81ca2d18","108":"f4cb4943","336":"86706c2b","512":"1a9004d4","599":"b282ceae","771":"6a382336"}[chunkId] + ".chunk.js";
};